module.exports = __webpack_public_path__ + "img/telephone-plus.d290f5dd.svg";